import { removeQueryParams } from '@framework/router';
import { pageRedirectTo, IRedirectResponse } from '@framework/router/Next/helpers';
import getDefaultQueryFilters from '../getDefaultQueryFilters';
import type { QuerySanitizer } from './types';
import type { ApplicationContext } from '@/creditflowresearch/application/withApplicationPropsV2';

type DefaultsOrFactory =
  | Record<string, string | string[]>
  | ((context: ApplicationContext) => Record<string, string | string[]>);

interface IQueryValidationConfig {
  defaults: DefaultsOrFactory,
  validators: Record<string, QuerySanitizer>,
  redirectUrl?: string,
  excludeParams?: string[],
}

type CallbackResult = { props: Record<string, unknown> };

const withQueryValidation = (
  config: IQueryValidationConfig,
  callback: (context: ApplicationContext) => Promise<CallbackResult>,
) => async (context: ApplicationContext): Promise<IRedirectResponse | CallbackResult> => {
  const { query } = context;
  const { defaults: defaultsOrFactory, validators, redirectUrl = '', excludeParams } = config;

  const defaults = typeof defaultsOrFactory === 'function'
    ? defaultsOrFactory(context)
    : defaultsOrFactory;

  const filteredQuery = excludeParams
    ? removeQueryParams(query, excludeParams)
    : query;

  const queryParams = getDefaultQueryFilters({
    query: filteredQuery,
    defaults,
    validators,
  });

  if (queryParams) {
    return pageRedirectTo(`${ redirectUrl }${ queryParams }`);
  }

  return callback(context);
};

export default withQueryValidation;
